import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './PaymentSubmit.css';
import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import ActionsPanel from '../ActionsPanel';
import { isEmpty, sumBy } from 'lodash';
import { getDictionaryItem, get } from '../../../../utils';
import { IconWarning, IconAlert } from '../../../atoms/Icons/';
import { GetPaymentURL, GetFees, Search, PaymentValidation } from '../actions';
import Cookies from 'js-cookie';
var StepRender = function StepRender(props) {
  var history = useHistory();
  var updateSteps = props.updateSteps,
    currentStepId = props.currentStepId,
    stepConfig = props.stepConfig,
    rtl = props.rtl,
    appRef = props.appRef,
    apiConfig = props.apiConfig,
    _props$appn = props.appn,
    appn = _props$appn === void 0 ? '' : _props$appn,
    _props$applicationNum = props.applicationNumber,
    applicationNumber = _props$applicationNum === void 0 ? '' : _props$applicationNum;
  var frame = useRef();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    paymentTokken = _useState2[0],
    setPaymentTokken = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    setTransactionToken = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    fees = _useState8[0],
    setFees = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showFrame = _useState10[0],
    setShowFrame = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isRequesting = _useState12[0],
    setIsRequesting = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    paymentUrl = _useState14[0],
    setpPymentUrl = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    errorServerMessage = _useState16[0],
    setErrorServerMessage = _useState16[1];
  var paymentUrlRef = useRef('');
  var _stepConfig$data = stepConfig.data,
    title = _stepConfig$data.title,
    pSaShortDescription = _stepConfig$data.pSaShortDescription,
    buttonContinueUrl = _stepConfig$data.buttonContinueUrl,
    dictionary = stepConfig.dictionary,
    dictionaryNavigation = stepConfig.dictionaryNavigation;
  var prevStepId = currentStepId - 1;
  var submitPageUrl = get(buttonContinueUrl, 'jss.value.href') || '/';
  var panelButtonState = {
    continue: {
      inactive: false,
      loading: isRequesting,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationSubmit')
    },
    back: {
      inactive: false,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationBack')
    },
    save: {
      inactive: true,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationSave')
    }
  };
  var panelButtonFrameState = _objectSpread(_objectSpread({}, panelButtonState), {}, {
    continue: {
      inactive: !paymentTokken.length,
      loading: isRequesting,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationSubmit')
    }
  });
  var panelActions = {
    contionueAction: function () {
      var _contionueAction = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$GetPaymentURL, _yield$GetPaymentURL$, paymentUrl, error, errorMessage, params, tokken;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setErrorServerMessage('');
              setIsRequesting(true);
              _context.next = 4;
              return GetPaymentURL(apiConfig, applicationNumber);
            case 4:
              _yield$GetPaymentURL = _context.sent;
              _yield$GetPaymentURL$ = _yield$GetPaymentURL.paymentUrl;
              paymentUrl = _yield$GetPaymentURL$ === void 0 ? '' : _yield$GetPaymentURL$;
              error = _yield$GetPaymentURL.error;
              setIsRequesting(false);
              if (!isEmpty(error)) {
                errorMessage = rtl && error.ar ? error.ar : error.en || '';
                setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
              }
              if (paymentUrl.length) {
                params = new URL(paymentUrl).searchParams;
                tokken = params.get('paymentRequestToken') || '';
                setpPymentUrl(paymentUrl);
                paymentUrlRef.current = paymentUrl;
                setTransactionToken(tokken || '');
                paymentUrl.length && setShowFrame(true);
              }
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function contionueAction() {
        return _contionueAction.apply(this, arguments);
      }
      return contionueAction;
    }(),
    saveAction: function () {
      var _saveAction = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function saveAction() {
        return _saveAction.apply(this, arguments);
      }
      return saveAction;
    }(),
    backAction: function backAction() {
      setErrorServerMessage('');
      updateSteps(prevStepId);
    }
  };
  var panelActionsFrame = _objectSpread(_objectSpread({}, panelActions), {
    contionueAction: function () {
      var _contionueAction2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var id, _yield$PaymentValidat, Success, error, errorMessage;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              setErrorServerMessage('');
              setIsRequesting(true);
              id = applicationNumber.length ? applicationNumber : appn;
              _context3.next = 5;
              return PaymentValidation(apiConfig, {
                applicationNumber: id,
                NoqodiPaymentAuthResultAsJSONString: paymentTokken
              });
            case 5:
              _yield$PaymentValidat = _context3.sent;
              Success = _yield$PaymentValidat.Success;
              error = _yield$PaymentValidat.error;
              setIsRequesting(false);
              if (isEmpty(error)) {
                _context3.next = 13;
                break;
              }
              errorMessage = rtl && error.ar ? error.ar : error.en || '';
              setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
              return _context3.abrupt("return");
            case 13:
              console.log(Success, error);
              if (Success) {
                Cookies.set('applicationNumber', id);
                history.push(submitPageUrl);
              }
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function contionueAction() {
        return _contionueAction2.apply(this, arguments);
      }
      return contionueAction;
    }()
  });
  useEffect(function () {
    appRef && appRef.current.scrollIntoView({
      behavior: 'smooth'
    });
    function fetchData(_x) {
      return _fetchData.apply(this, arguments);
    }
    function _fetchData() {
      _fetchData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(appnId) {
        var _yield$Search, applicationData, error, errorMessage;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return Search(apiConfig, appnId);
            case 2:
              _yield$Search = _context4.sent;
              applicationData = _yield$Search.applicationData;
              error = _yield$Search.error;
              setIsRequesting(false);
              if (isEmpty(error)) {
                _context4.next = 10;
                break;
              }
              errorMessage = rtl && error.ar ? error.ar : error.en || '';
              setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
              return _context4.abrupt("return");
            case 10:
              setData(applicationData);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _fetchData.apply(this, arguments);
    }
    function fetchFees(_x2) {
      return _fetchFees.apply(this, arguments);
    }
    function _fetchFees() {
      _fetchFees = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(appnId) {
        var _yield$GetFees, feesList, error, errorMessage;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              setIsRequesting(true);
              _context5.next = 3;
              return GetFees(apiConfig, appnId);
            case 3:
              _yield$GetFees = _context5.sent;
              feesList = _yield$GetFees.feesList;
              error = _yield$GetFees.error;
              setIsRequesting(false);
              if (isEmpty(error)) {
                _context5.next = 11;
                break;
              }
              errorMessage = rtl && error.ar ? error.ar : error.en || '';
              setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
              return _context5.abrupt("return");
            case 11:
              setFees(feesList);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return _fetchFees.apply(this, arguments);
    }
    if (applicationNumber.length || appn && appn.length) {
      var id = applicationNumber.length ? applicationNumber : appn;
      fetchData(id);
      fetchFees(id);
    } else {
      history.push(apiConfig.dashboardUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var reloadFrame = function reloadFrame(message) {
    setShowFrame(false);
    setErrorServerMessage(message);
  };
  var getFrameData = function getFrameData(e) {
    if (!paymentUrlRef.current.length) return;
    var parcedUrl = new URL(paymentUrlRef.current);
    var origin = parcedUrl && parcedUrl.origin;
    if (e.origin !== origin || !e.data) {
      return;
    }
    var responseJson = JSON.parse(e.data);
    if (responseJson && responseJson.statusInfo && responseJson.statusInfo.status && responseJson.statusInfo.status === 'SUCCESS') {
      setPaymentTokken(e.data.replaceAll('"', '%22') || '');
    } else {
      var message = responseJson.error && responseJson.error.statusInfo && responseJson.error.statusInfo.errorCode && responseJson.error.statusInfo.errorCode.message && responseJson.error.statusInfo.errorCode.message || responseJson.statusText;
      reloadFrame(message || '');
    }
    //
  };
  useEffect(function () {
    if (!window) return;
    window.addEventListener('message', getFrameData, false);
    return function () {
      window.removeEventListener('message', getFrameData);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: 'h2',
    field: title || {
      value: ''
    }
  }), /*#__PURE__*/React.createElement(RichText, {
    className: "description",
    field: get(pSaShortDescription, 'jss')
  }))))), showFrame ? /*#__PURE__*/React.createElement("div", {
    className: "module-group-app"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("iframe", {
    ref: frame,
    src: paymentUrl,
    className: "iframe",
    title: "payment-frame"
  }))), errorServerMessage.length ? /*#__PURE__*/React.createElement("div", {
    className: "error-message"
  }, errorServerMessage) : '') : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "module-group-app module-group-app--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-indent"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6 header-table"
  }, /*#__PURE__*/React.createElement("p", {
    className: "header-table__name"
  }, getDictionaryItem(dictionary, 'ApplicantName')), /*#__PURE__*/React.createElement("p", {
    className: "header-table__value"
  }, data && data.ApplicantName && (rtl ? data.ApplicantName.AR : data.ApplicantName.EN))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6 header-table"
  }, /*#__PURE__*/React.createElement("p", {
    className: "header-table__name"
  }, getDictionaryItem(dictionary, 'ApplicationNumber')), /*#__PURE__*/React.createElement("p", {
    className: "header-table__value"
  }, applicationNumber))), /*#__PURE__*/React.createElement("div", {
    className: "row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-chart col-md-12"
  }, /*#__PURE__*/React.createElement("table", {
    className: 'table-chart__table'
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, getDictionaryItem(dictionary, 'Type')), /*#__PURE__*/React.createElement("th", null, getDictionaryItem(dictionary, 'FeeAmount')))), /*#__PURE__*/React.createElement("tbody", null, fees.map(function (_ref, index) {
    var amount = _ref.amount,
      nameEn = _ref.nameEn,
      nameAr = _ref.nameAr;
    var title = rtl ? nameAr : nameEn;
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, title), /*#__PURE__*/React.createElement("td", null, amount));
  }), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "result"
  }, /*#__PURE__*/React.createElement("div", {
    className: "result-wrapper"
  }, /*#__PURE__*/React.createElement("span", null, " ", getDictionaryItem(dictionary, 'total') || 'TOTAL', " :"), /*#__PURE__*/React.createElement("span", {
    className: "result__count"
  }, sumBy(fees, function (_ref2) {
    var amount = _ref2.amount;
    return amount;
  })), /*#__PURE__*/React.createElement("span", null, " ", getDictionaryItem(dictionary, 'AED') || 'AED')))))))), errorServerMessage.length ? /*#__PURE__*/React.createElement("div", {
    className: "error-message"
  }, errorServerMessage) : ''), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("p", {
    className: "alert-box"
  }, /*#__PURE__*/React.createElement(IconAlert, null), getDictionaryItem(dictionary, 'PaymentSubmitApplicationAlert')), /*#__PURE__*/React.createElement("p", {
    className: "info-box module-group-wrap"
  }, /*#__PURE__*/React.createElement(IconWarning, null), getDictionaryItem(dictionary, 'PaymentSubmitApplicationMessage'))))), showFrame ? /*#__PURE__*/React.createElement(ActionsPanel, {
    rtl: rtl,
    actions: panelActionsFrame,
    buttonState: panelButtonFrameState
  }) : /*#__PURE__*/React.createElement(ActionsPanel, {
    rtl: rtl,
    actions: panelActions,
    buttonState: panelButtonState
  }));
};
var commonStyles = "c1aajxvm";
var rtlStyles = "reivnau";
var ltrStyles = "l1n43fc5";
export default StepRender;